import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/siteData";

export default function Footer() {
  const footerLinks = [
    {
      title: "内容分类",
      links: [
        { label: "白丝材质选择", href: "/category/material" },
        { label: "足部护理", href: "/category/care" },
        { label: "互动姿势", href: "/category/positions" },
        { label: "情趣提升", href: "/category/enhancement" },
      ],
    },
    {
      title: "关于我们",
      links: [
        { label: "品牌介绍", href: "/about" },
        { label: "联系方式", href: "/about#contact" },
        { label: "隐私政策", href: "/about" },
      ],
    },
  ];

  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full px-6 md:px-10 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12">
            <div>
              <h4 className="text-base font-semibold text-foreground-950 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
                {siteInfo.name}
              </h4>
              <p className="text-sm text-foreground-600 leading-relaxed">
                为成人伴侣提供专业、私密的白丝足交参考内容。涵盖材质选择、足部护理、互动姿势及情趣提升全攻略。
              </p>
            </div>

            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="text-sm font-semibold text-foreground-950 mb-4 uppercase tracking-wide">
                  {group.title}
                </h4>
                <ul className="space-y-2">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.href}
                        className="text-sm text-foreground-600 hover:text-accent-500 transition-colors duration-200"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} {siteInfo.name}. 本站内容仅供成年人参考。
            </p>
            <p className="text-xs text-foreground-500">
              请确认您已年满18周岁
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}